module.exports = __webpack_public_path__ + "img/collection-memoireRingsAsWeddingRings@2x.d6eefa4.jpg";